import styled from 'styled-components';

import { Tooltip } from '@frontend/legacy-components';
import { utils } from '@frontend/partviewer';
import type { UNITS } from '@frontend/partviewer/src/constants';

import { formatFloat } from 'utils/formatters';

const { formatLengthProp } = utils;

const MeasurementComparisonContainer = styled.div`
  color: inherit;
  font-size: 13px;
  margin-bottom: 10px;
  text-align: right;
  width: 200px;
`;

const Title = styled.span`
  font-weight: 700;
  margin-bottom: 5px;
`;

const EntryWrapper = styled.div``;

const EntryTitle = styled.span`
  margin-right: 5px;
`;

const EntryValue = styled.span``;

type MeasurementComparisonComponentProps = {
  comparison: {
    angle: number;
    resolution: string;
    type: string;
  };
  currentMeasurementValue: number | null;
  displayScale: number;
  displayUnits: UNITS;
  nativeUnits: UNITS;
  dimensionalPrecision: number;
};

const MeasurementComparisonComponent = ({
  comparison,
  currentMeasurementValue,
  displayScale,
  displayUnits,
  nativeUnits,
  dimensionalPrecision,
}: MeasurementComparisonComponentProps) => {
  return comparison && currentMeasurementValue !== null ? (
    <MeasurementComparisonContainer>
      <Title>Measurement</Title>
      <EntryWrapper>
        <EntryTitle>Distance:</EntryTitle>
        <EntryValue>
          {formatLengthProp({
            value: currentMeasurementValue,
            order: 1,
            displayUnits,
            nativeUnits,
            dimensionalPrecision,
            displayScale,
          })}
        </EntryValue>
      </EntryWrapper>
      <Tooltip placement="bottom" label={`Type: ${comparison.type}`}>
        <EntryWrapper>
          <EntryTitle>Angle</EntryTitle>
          {comparison.resolution ? (
            <EntryValue>{`${formatFloat(
              (comparison.angle * 180) / Math.PI,
              3,
            )}\u00b0 (${comparison.resolution})`}</EntryValue>
          ) : (
            <EntryValue>{`${formatFloat(
              (comparison.angle * 180) / Math.PI,
              3,
            )}\u00b0`}</EntryValue>
          )}
        </EntryWrapper>
      </Tooltip>
    </MeasurementComparisonContainer>
  ) : null;
};

export default MeasurementComparisonComponent;
